
import './styles.css';
// import InsaneTable from '../../component/insane-table';

function SettingsPermission() {

    // const tableOption = {
    //     tableName: "Equipment",
    //     className: "",
    //     search: [
    //         {
    //             reqName: "equipmentgroupid",
    //             displayName: "Group ID",
    //             type: "input",
    //             placeholder: "Enter Group ID."
    //         }
    //     ],
    //     mapTable: [
    //         {
    //             displayName: "Group ID",
    //             attName: "equipmentgroupid",
    //             type: "text",
    //         },
    //         {
    //             displayName: "Equipment ID",
    //             attName: "equipmentid",
    //             type: "text",
    //         },
    //         {
    //             displayName: "Tag ID",
    //             attName: "tagid",
    //             type: "text",
    //         },
    //         {
    //             displayName: "Unit",
    //             attName: "unit",
    //             type: "text"
    //         }
    //     ],
    //     api: {
    //         view: {
    //             enable: true,
    //             url: "/admin/equipment/get",
    //             dataReq: {
    //                 "index": 0,
    //                 "count": 10
    //             }
    //         },
    //         insert: {
    //             enable: false,
    //             url: "/admin/equipment/update",
    //             dataReq: {
    //                 "plantname": ""
    //             }
    //         },
    //         update: {
    //             enable: false,
    //             url: "/admin/equipment/update",
    //             dataReq: {
    //                 "plantid": "",
    //                 "plantname": ""
    //             }
    //         },
    //         delete: {
    //             enable: false,
    //             url: "/admin/equipment/delete",
    //             dataReq: {
    //                 "plantid": ""
    //             }
    //         }
    //     },
    //     action: [
    //         // {
    //         //     name: "Edit",
    //         //     mode: "modal-form", /// page, modal, form
    //         //     option: {
    //         //         type: "update"
    //         //     }
    //         // }
    //     ]
    // }

    return (
        <div className='content'>

            <div className='content-page'>
                <div className='head-content-page'>Permission is coming soon.</div>
                {/* <InsaneTable option={tableOption}></InsaneTable> */}
            </div>

        </div >
    );
}

export default SettingsPermission;